import script from "./xieyi.vue?vue&type=script&lang=ts&setup=true"
export * from "./xieyi.vue?vue&type=script&lang=ts&setup=true"

import "./xieyi.vue?vue&type=style&index=0&id=0cc68fbc&lang=scss&scoped=true"

import exportComponent from "E:\\gitProject\\营城\\yingcheng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc68fbc"]])

export default __exports__